// src/utils/stringUtils.js
export const getInitials = (name = "") => {
    return name
        .split(" ")
        .map((word) => word.charAt(0).toUpperCase())
        .join("")
        .slice(0, 2);
};
